<p-datepicker
  [(ngModel)]="selection"
  [disabledDates]="disabledDates | async"
  [readonlyInput]="true"
  [showOtherMonths]="showOtherMonths"
  [selectOtherMonths]="true"
  appendTo="body"
  [disabled]="!!(disabled || readonly)"
  [numberOfMonths]="_numberOfMonths | async"
  [tabindex]="tabindex"
  [inputId]="inputId"
  [name]="name"
  [selectionMode]="selectionMode"
  [inline]="!!inline"
  ngDefaultControl
  (onMonthChange)="ChangeMonth($event)"
  (onFocus)="OnFocus()"
  (onSelect)="OnSelect($event)">
  <ng-template pTemplate="date" let-date>
    <span class="cal-day">
      <span>{{ date.day }}</span>
      <span class="cal-footer">
        @for(status of (GetShiftStatuses(date) | async); track status) {
          <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="5" [ngClass]="status" />
          </svg>
        }
      </span>
    </span>
  </ng-template>
  <ng-template pTemplate="footer">
    <span class="legend">
      @for(status of ['Open', 'Closed', 'Locked']; track status) {
        <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
          <circle cx="5" cy="5" r="5" [ngClass]="status" />
        </svg>
        {{status}}
      }
    </span>
  </ng-template>
</p-datepicker>
